<template>
    <div class = "tags-input-and-results" @click="openResults(true)" v-click-away="closeResults">

        <div class="tags-and-input">
            <div class="tags">
                <template v-for="category in modelValue" :key="category.name">
                    <div class="tag" @click="remove(category.name)">
                        {{ ($translation(category.name)) }} &nbsp; &nbsp; x
                    </div>
                </template>
            </div>     
            <input 
              @focus="openResults()" 
              :placeholder="modelValue.length?'':placeholder" 
              class="search-input" 
              v-model="search" 
              v-if="modelValue.length===0"
            />
          </div>
          <small v-if="errorMessage" :class="{ 'p-error': true }">{{ errorMessage }}</small>
        <div class="search-results" v-if="searchVisible"> 
          <div class="custom-result" v-if="search!=''" @click="addCategoryAndClose(preprocessSearchResult({name:search,value:search}))">{{ search }}</div>
          <TMultiselectTree @select="addCategoryAndClose" :categories="filteredList"/>
        </div>
      </div>
</template>
<script>

import TMultiselectTree from "./TMultiselectTree.vue";
import { useField } from "vee-validate/dist/vee-validate.min.js";


export default {
  components: {
    TMultiselectTree,
 
  },
  setup(props,{ emit })
  {
    const { value, errorMessage } = useField(props.name, undefined, {
      initialValue: props.modelValue, valueProp:props.modelValue
    });

    return{
      errorMessage,
      value
    }
  },
  props: {
    type: {
      default: "select",
    },
    name: {
      type: String,
      default: "",
    },
    categories: {
      default: [],
    },
    modelValue: [],
    placeholder: {
      default: "",
    },
    emmit_at_watch:{
      type:Boolean,
      default:true
    }
  },
  emits: ["update:modelValue","change", "input"],
  $_veeValidate:{
    value(){
      return this.modelValue
    },
    name(){
      return this.name
    }
  },
  data() {
    return {
      pageMetas: null,
      search: "",
      searchVisible: false,
      selectedCategories: [],
    };
  },

  mounted() {},

  methods: {
    async getCatTree() {
      var data = await this.categoryService.getTree();
      this.categoriesList = data.data.data;
    },

    addCategoryAndClose(e) {
      this.addCategory(e);
      this.closeResults();
      this.search = "";
    },

      addCategory(e,emmit=true)
      {
       
        if(this.type=='select' && this.selectedCategories.length) return
        let index = this.selectedCategories.findIndex(x=>x.name==e.name)
        if(index<0)
        {
            this.selectedCategories.push(e)
            this.value = this.selectedCategories
            
            if(emmit)
            {
              this.$emit('update:modelValue',this.selectedCategories)
              this.$emit('change',this.selectedCategories)
              this.$emit('input',this.selectedCategories)
              
            }
              
        }
      },

    checkIfSearchExistsInTree(e, root) {
      let existingCategory = root.find(
        (x) => x.name.toLowerCase() == e.name.toLowerCase()
      );
      if (existingCategory) return existingCategory;
      for (let i = 0; i < root.length; i++) {
        let cat = root[i];

        if (cat.children) {
          existingCategory = this.checkIfSearchExistsInTree(e, cat.children);
          if (existingCategory) return existingCategory;
        }
      }
      return false;
    },

    preprocessSearchResult(e) {
      let existingCategory = this.checkIfSearchExistsInTree(e, this.categories);

      if (existingCategory)
        return {
          name: existingCategory.name,
          value: existingCategory.id,
          id: existingCategory.id,
        };

      return e;
    },

      remove(name)
      {
        let index = this.selectedCategories.findIndex(x=>x.name==name)
        this.selectedCategories.splice(index,1)
        this.value = this.selectedCategories
        this.$emit('update:modelValue',this.selectedCategories)
        this.$emit('change',this.selectedCategories)
        this.$emit('input',this.selectedCategories)
        console.log("FFF")
      },

    openResults() {
      this.searchVisible = true;
    },
    closeResults() {
      this.searchVisible = false;
      this.search = "";
    },
  },
  computed: {
    filteredList() {
      let that = this;
      if (this.search === "") {
        return this.categories;
      } else {
        let result = [];
        function buildResultTree(root, search, result) {
          for (let i = 0; i < root.length; i++) {
            let element = root[i];
            if (element.name.toLowerCase().match(search.toLowerCase())) {
              result.push(element);
            } else if (Array.isArray(element.children)){
              buildResultTree(element.children, search, result);
            }
          }
        }

        buildResultTree(this.categories, this.search, result);
        return result;
      }
    },
  },

  watch:{
    
    modelValue: {
      handler: function(newValue,oldValue) {
        this.selectedCategories = []
        for (let i =0; i<newValue.length;i++)
        {
            this.addCategory(newValue[i],false)
        }
        if(JSON.stringify(newValue)!=JSON.stringify(oldValue)&&this.emmit_at_watch)
        {
          this.$emit('update:modelValue',this.selectedCategories)
          this.$emit('change',this.selectedCategories)
          this.$emit('input',this.selectedCategories)
        }
        this.value = this.selectedCategories

      },
      deep: true,
    },

    categories: {
      handler: function(newValue,oldValue) {
      
      },
      deep: true,
    }
  },
};
</script>

<style lang="scss" scoped>
.tag {
 
  width: max-content;
  padding: 7px 5px;
  white-space: nowrap;
  border-radius: 4px;
  cursor: pointer;
  background: $grey !important;
  color: white;
  @include f-input;
  //font-weight: 500;
  margin: 5px 5px;

}

.tags-input-and-results {
  width: 100%;
  position: relative;
  margin-bottom: 15px;
}
.tags {
  flex-wrap: wrap;
  display: flex;
  max-width:100%
}

.search-input {
  width: 100%;
  min-width: 100px;
  border: none;
}

.search-input::-webkit-input-placeholder {
  //color: $grey;
  @include f-input;
}
.search-input:-moz-placeholder {
  //color: $grey;
  @include f-input;
}
.search-input:focus-visible {
  outline: none;
}
.tags-and-input {
  width: 100%;
  display: flex;
  border-radius: 4px;
  border: 1px solid;
  border-color: $border-color;
  padding: 5px;
  background-color: white;
}

.search-results {
  position: absolute;
  max-height: 150px;
  overflow-y: scroll;
  z-index: 30;
  width: 100%;
  background-color: white;
  border: 1px solid $border-color;
  border-radius: 5px;
  padding: 10px;
  @include f-input;
}
.custom-result {
  cursor: pointer;
  color: green;
}

.custom-result:hover {
  background-color: lightgray;
}
</style>
